webpackJsonp([195918081234686],{

/***/ 1388:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ComplicationInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"isMajor","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-complication-input-e2c7486c2d2d70b01e48.js